<div class="header-container" [class.left]="position === 'normal'" [class.right]="position === 'inverse'">
  <div class="logo-containter mr-0">
    <a *ngIf="showHeader == 1" (click)="toggleSidebar()" href="#" class="navigation"><i class="nb-menu"></i></a>
    <div (click)="goToHome()" class="cursor"><img src="../assets/images/logo.png" height="60px"></div>
  </div>
  <!-- <ngx-theme-switcher *ngIf="showHeader == 1"></ngx-theme-switcher> -->
  <!-- <ngx-layout-direction-switcher *ngIf="showHeader == 1"></ngx-layout-direction-switcher> -->
</div>
<nb-actions *ngIf="showHeader == 1" size="medium" [class.right]="position === 'normal'"
  [class.left]="position === 'inverse'">
  <nb-action>
    <div class="all_devices header-container mr-4" *ngIf="subscriptionType && showOptions">
      <h4 class="text-primary font-weight-normal text-capitalize"
        *ngIf="router.url != '/login' && router.url != '/' && router.url != '/signup'">{{subscriptionType}} Customer
      </h4>
    </div>
    <div class="all_devices header-container"
      *ngIf="router.url != '/login' && router.url != '/' && router.url != '/signup'">
      <div class="dropdown">
        <img src="{{imageURL}}" class="circle" alt="">
        <span class="mr-2 ml-2">{{userDetails.firstname}} {{userDetails.lastname}}</span><i
          class="fa fa-caret-down"></i>
        <ul class="dropdown-content">
          <!-- <a><span class="m-r-10"><i class="fa fa-wrench "></i></span>Setting</a>
          <a><span class="m-r-10"><i class="fa fa-user "></i></span>Profile</a>
          <a><span class="m-r-10"><i class="fa fa-info "></i></span>Help</a> -->
          <a (click)="gotoMyProfile()"><span class="m-r-10"><i class="fa fa-user" aria-hidden="true"></i></span>My
            Profile</a>
          <a (click)="logout()"><span class="m-r-10"><i class="fa fa-sign-out" aria-hidden="true"></i></span>Logout</a>
        </ul>
      </div>
    </div>
    <div class="small_devices header-container" *ngIf="router.url != '/login' && router.url != '/'">
      <div class="mr-1" *ngIf="subscriptionType">
        <label class="text-primary font-weight-bold text-capitalize">{{subscriptionType}} Customer</label>
      </div>
      <div class="dropdown">
        <img src="{{imageURL}}" class="circle" alt="">
        <ul class="dropdown-content">
          <span class="m-r-10 user-name">{{userDetails.firstname}} {{userDetails.lastname}}</span>
          <!-- <a><span class="m-r-10"><i class="fa fa-wrench "></i></span>Setting</a>
          <a><span class="m-r-10"><i class="fa fa-user "></i></span>Profile</a>
          <a><span class="m-r-10"><i class="fa fa-info "></i></span>Help</a> -->
          <a (click)="gotoMyProfile()"><span class="m-r-10"><i class="fa fa-user" aria-hidden="true"></i></span>My
            Profile</a>
          <a (click)="logout()"><span class="m-r-10"><i class="fa fa-sign-out" aria-hidden="true"></i></span>Logout</a>
        </ul>
      </div>
    </div>
  </nb-action>
</nb-actions>
